module.exports = {
  // 菜单栏Class
  menuClass: {
    enterprise: 'Overview of corporate accounts',
    personal: 'Personal Account Overview',
    changePassword: 'Change Password'
  },
  // 登录注册Class
  loginClass: {
    userLogin: 'User Login',
    account: 'Mobile No./ Email Add.',
    password: 'Password',
    login: 'Log in',
    registerTips: 'Cloud Money Log in',
    realName: 'Your Real Name',
    mobile: 'Your Mobile No.',
    verificationCode: 'Verification Code',
    submit: 'Submit',
    agreeTips: 'I Have Read and Agree',
    agreementTips: '《Cloud Money Agreement》',
    register: 'Register',
    registerDone: 'Register Done',
    tel: 'Mobile No',
    logout: 'Log Out',
    logoutTips: 'Are you sure to log out？',
    systemTips: 'System Prompt',
    cancel: 'Cancel'
  },
  // 企业账户&&个人账户Class
  accountClass: {
    accountRelated: 'Account Related',
    corporateAccounts: 'Overview of corporate accounts',
    accountManagement: 'Corporate associated account management',
    accountOverview: 'Personal Account Overview',
    overviewManagement: 'Overview of account management',
    cloudPoint: 'Cloud Point Account',
    TEUCurrency: 'TEU Currency',
    recharge: 'Recharge',
    membership: 'Purchase a membership',
    details: 'Transaction Details',
    membershipPeriod: 'Membership Period',
    benefitsAvailable: 'Benefits Available',
    welcome: 'Welcome',
    userID: 'User ID',
    accountID: 'AccountID',
    exit: 'Exit',
    personal: 'Personal',
    personalDetails: 'Individual transaction details',
    enterpriseDetails: 'Business transaction details',
    tips: 'Please enter the added user ID. If the added user is not registered, please register it first',
    personalAccountID: 'Personal AccountID',
    companyAccountID: 'Company AccountID'
  },
  // 企业交易明细&&个人交易明细Class
  tradingClass: {
    startDate: 'Start Date',
    endDate: 'End Date',
    transactionDate: 'Transaction date',
    tradeSources: 'Trade sources',
    transactionType: 'Transaction type',
    all: 'All',
    consumption: 'Consumption',
    reconciliation: 'Reconciliation',
    transactionGifts: 'Transaction Gifts',
    membershipRecharge: 'Membership Recharge',
    confirmMembership: 'Confirm Membership',
    confirmRecharge: 'Confirm Recharge',
    cloudBl: 'Cloud B/l',
    cloudBooking: 'Cloud Booking',
    cloudExhibition: 'Cloud Exhibition',
    cloudMondy: 'Cloud Mondy',
    mall: 'Higosky Mall',
    transactionTime: 'Transaction Time',
    trader: 'Trader',
    accountName: 'Account Name',
    transactionNo: 'Transaction No.',
    transactionAmount: 'Transaction Amount',
    pointBalance: 'Member Point Balance ',
    amountPay: 'Amount actually paid (RMB)',
    usdAmountPay: 'Amount actually paid (USD)',
    note: 'Note',
    download: 'Download',
    query: 'Query',
    account: 'Account',
    jyjetcoin: 'Transaction Amount（TEU COIN）',
    zhyetcoin: 'Account Balance(TEU COIN)',
    balance: 'Balance',
    enterCode: 'Pls Enter Code',
    send: 'Send',
    transfer: 'Transfer',
    transferAmount: 'Transfer Amount'
  },
  // 会员Class
  membersClass: {
    membersTips: 'A membership fee of XXXX is required',
    membersTips1: 'A membership fee of ',
    membersTips2: ' is required',
    bronzeMember: 'Bronze member',
    goldMember: 'Gold member',
    platinumMember: 'Platinum member',
    benefitsAvailable: 'Benefits Available',
    paymentChecking: 'Payment in Checking',
    bemembers: 'Become a member and enjoy more rights!',
    nonmembbers: 'No rights for non-members',
    validity: 'Membership period',
    equity: 'Available interest',
    review: 'You have payment, waiting for the platform in artificial check to confirm',
    selectHoder: 'Please select a membership grade'
  },
  // 充值Class
  rechargeClass: {
    rechargeAmount: 'Recharge Amount',
    wechatPay: 'WeChat pay',
    alipay: 'Alipay Payment',
    offlinePay: 'Please transfer to the bank account below',
    qrcode: 'Payment QR Code',
    rechargeTips: 'Please remit XXXX YUAN to XXXX.Please contact customer service after remittance. If you have any questions, please contact XXXX',
    tips1: 'Please remit',
    tips2: 'YUAN',
    tips3: 'to',
    tips4: '',
    tips5: 'Account name is',
    tips6: 'Please contact customer service after remittance. If you have any questions, please contact',
    rechargeTips: 'Recharge completed, Waiting for confirmation!',
    offlinePayTitle: 'Offline Pay'
  },
  // 账号管理Class
  managementClass: {
    userID: 'User ID',
    userName: 'User Name',
    email: 'Email',
    permissions: 'Permissions',
    operation: 'Operation',
    administrator: 'Administrator (Chief of Enterprise)',
    payPart: 'Pay Part',
    update: 'Update',
    delete: 'Delete',
    addAccount: 'Add an associated account',
    addID: 'User ID is added',
    managementTips: 'Enter the added user ID.Rregister first if not yet.',
    setPermissions: 'Set permissions',
    select: 'Select',
    sure: 'Sure',
    updateAccount: 'UpdateAccount',
    role: 'Please select role permissions',
    deleteTips: 'Are you sure you want to delete',
    deleteTips2: 'This account?',
    tips: 'Prompt',
    cancelDelete: 'Delete has been canceled',
    deleteSucc: 'Delete successful！',
    deleteFuil: 'Delete failed！'
  },
  checkClass: {
    accountTips: 'Please enter your account ID',
    permissions: 'Please select permissions'
  },
  sidebarClass: {
    individualAccount: 'Individual Account',
    personalOverview: 'Personal Account Overview',
    personalCredit: 'Personal Credit',
    personalDetails: 'Personal Transaction Details',
    companyAccount: 'Company Account',
    companyOverview: 'Company Account Overview',
    companyRecharge: 'Company Recharge',
    purchaseMember: 'Purchase Member',
    companyDetails: 'Company Transaction Details',
    accountManagement: 'Account Management',
    companyManagement: 'Company Account Management',
    personalAccountTransfer: 'Personal Transfer',
    companyTransfer: 'Company Transfer'
  },
  bankTransferClass: {
    companyAccount: 'BENEFICIARY\'S A/C NO.',
    remittanceAmount: 'REMITTANCE AMOUNT',
    bankAccount: 'BENEFICIARY\'S BANK',
    account: 'BENEFICIARY',
    contact: 'CONTACT US',
    contactNumber: 'TEL.',
    contactWeChat: 'WECHAT',
    unit: 'CNY',
    email: 'Email',
    swift: 'SWIFT CODE',
    whatapp: 'WHATSAPP',
    address: 'ADDRESS'
  },
  changePasswordClass: {
    // 原密码
    originalPassword: 'Original Password：',
    inputOriginalPassword: 'Please enter the original password',
    // 新密码
    newPassword: 'New Password：',
    inputNewPassword: 'Please enter a new password',
    // 确认新密码
    sureNewPassword: 'Confirm New Password：',
    inputSureNewPassword: 'Please confirm the new password',
    // 修改密码
    changePassword: 'Change Password',
    // 格式校验
    format: 'Please enter the password in the correct 8-16 bit format'
  },
  commonPayClass: {
    orderNo: 'Order No',
    purpose: 'Purpose',
    orderContent: 'Order Content',
    paymentMethod: 'Payment Method',
    amount: 'Amount',
    pay: 'Pay',
    commitBtn: 'Confirm',
    paymentCenter: 'Payment Center',
    currency: 'USD',
    paypalTitle: 'Paypal',
    payAmount: 'Amount',
    teucoinPayment: 'Teu Coin Payment',
    offlinePayment: 'Offline Payment',
    onlinePayment: 'Online Payment',
    balance: 'remaining sum',
    centralAccount: 'WIFFA General Account',
    enterpriseAccount: 'Enterprise Account',
    individualAccount: 'Individual Account',
    verificationCode: 'Security code',
    recharge: 'Recharge'
  },
  commonPayResultClass: {
    statusSuccessTitle: 'Payment completed',
    statusFailTitle: 'Payment failed',
    resultSuccessTitle: 'Order payment completed',
    resultFailTitle: 'Order payment failed',
    orderNo: 'Order No',
    slipNo: 'Payment slip No',
    paymentMethod: 'Payment method',
    amount: 'Amount',
    returnBack: 'Back',
    returnInvoiceBack: 'Apply for invoice',
    currency: 'USD',
    accountId: 'TEUCOIN Account',
    copyBtn: 'Copy',
    orderInfo: 'Order Content',
    accountInfo: 'Bank Account',
    returnHome: 'Back to Home Page',
    selectOrder: 'View Order',
    paymentCompleted : 'Payment Succeeded',
    paymentDescription : 'You can view it in "My Orders" in the Personal Center'
  },
  // 开具发票
  invoiceInfoClass: {
    companyName: 'Name',
    invoiceTaxNo: 'Duty Paragraph',
    address: 'Address',
    phone: 'Phone',
    bankName: 'Bank of deposit',
    bankCode: 'BankCode',
    amount: 'Issuing Amount',
    issuedPhone: 'Push Phone',
    issuedEmail: 'Push Mailbox',
    selectsure: 'Confirm',
    cancel: 'Cancel',
    invoiceCompanyNameNotNull: 'Name cannot be empty',
    invoiceTaxNoNotNull: 'Tax No. cannot be empty',
    permissionsinvoiceIssuedPhoneNotNull: 'Push phone cannot be empty',
    invoiceIssuedEmailNotNull: 'Push mailbox cannot be empty'

  }
}
